import { useContext } from 'react';

import { OrgIdContext } from './OrgIdContext';

const useStoredOrganizationId = () => {
  const context = useContext(OrgIdContext);
  if (!context) {
    throw new Error(
      'Stored org context should be used within OrgIdContextProvider'
    );
  }

  return {
    orgId: context.orgId,
    setOrgId: context.setOrgId,
  };
};

export { useStoredOrganizationId };
